<template>
    <span v-bind="[$attrs]">
        {{
            dispatchRequestLine?.product_name
            ?? dispatchRequestLine?.sales_order_line?.product_name
            ?? dispatchRequestLine?.dispatch_request_lines?.[0]?.sales_order_line?.product_name
            ?? dispatchRequestLine?.metadata?.pim_data?.attributes?.productnaam_logistiek
            ?? `Onbekend product: ${dispatchRequestLine?.product_identifier}`
        }}
    </span>
</template>

<script>
export default {
    name: 'ProductScannedInfo',
    props: {
        dispatchRequestLine: {required: true},
    }
}
</script>
